// src/components/structure/StructureOverlay.js
import { useLocale } from '../../contexts/LocaleContext';
import { useAppConfig } from '../../contexts/AppConfigContext';
import {
  OverlayTableContainer,
  OverlayCell,
  HeaderContent,
  Label,
} from '../../styles/controllerPageStyles';

const StructureOverlay = ({ activeItem, columns }) => {
  const { t } = useLocale();
  const { config: appConfig } = useAppConfig();

  if (!activeItem) {
    return null;
  }

  const renderRowOverlay = () => (
    <tbody>
      <tr>
        <OverlayCell>☰</OverlayCell>
        {columns.map((col) => (
          <OverlayCell key={`overlay-row-${col.id}`}>
            {activeItem.type === 'break'
              ? (col.label === appConfig.requiredTimeKey ? activeItem.time : (col.label === appConfig.requiredLevelKey ? t('common.break') : '—'))
              : String(activeItem[col.label] ?? '')}
          </OverlayCell>
        ))}
        <OverlayCell>⋮</OverlayCell>
      </tr>
    </tbody>
  );

  const renderColumnOverlay = () => (
    <>
      <thead>
        <tr>
          <OverlayCell>
            <HeaderContent>
              <Label>{t(activeItem.header.label) || activeItem.header.label}</Label>
            </HeaderContent>
          </OverlayCell>
        </tr>
      </thead>
      <tbody>
        {activeItem.cells.map(cell => (
          <tr key={cell.rowId}>
            <OverlayCell>
              {cell.type === 'break' && activeItem.header.label !== 'common.time'
                ? '—'
                : String(cell.value ?? '')}
            </OverlayCell>
          </tr>
        ))}
      </tbody>
    </>
  );

  return (
    <OverlayTableContainer>
      {activeItem.type === 'column' ? renderColumnOverlay() : renderRowOverlay()}
    </OverlayTableContainer>
  );
};

export default StructureOverlay;
